<template>
    <page :busy="busy" :tabs="tabs" :compact-mobile-view="true">
        <router-view
            @busy="handleBusy"
        ></router-view>
    </page>
</template>

<script>
    import Page from '../generic/page/page.vue';

    export default {
        name: 'CustomVariables',
        components: {
            Page,
        },
        mounted() {
            if (this.$route.path === '/app/custom-variable/') {
                const tab = this.getActiveTab();
                if (tab) {
                    this.$router.push(`/app/custom-variable/${tab}/`);
                } else {
                    this.customVariablesRedirect();
                }
            }
        },
        computed: {
            tabs() {
                const tabs = [];
                tabs.push({
                    title: `Global Variables`,
                    route: `/app/custom-variable/global-variables/`,
                    active: this.$route.path === `/app/custom-variable/global-variables/`,
                    callback: this.setGlobalVariablesActiveTab,
                });
                tabs.push({
                    title: `Property Variables`,
                    route: `/app/custom-variable/property-variables/`,
                    active: this.$route.path === `/app/custom-variable/property-variables/`,
                    callback: this.setPropertyVariablesActiveTab,
                });
                // tabs.push({
                //     title: `Invoice Variables`,
                //     route: `/app/custom-variable/invoice-variables/`,
                //     active: this.$route.path === `/app/custom-variable/invoice-variables/`,
                //     callback: this.setInvoiceVariablesActiveTab,
                // });
                return tabs;
            }
        },
        data() {
            return {
                busy: false,
                localStorageActiveTabKey: 'customVariablesActiveTabKey',
            }
        },
        methods: {
            handleBusy(busy) {
                this.busy = busy;
            },
            getActiveTab() {
                const valid = ['global-variables', 'property-variables', 'invoice-variables'];
                const tab = localStorage.getItem(this.localStorageActiveTabKey);
                if (valid.includes(tab)) {
                    return tab;
                }
                return null;
            },
            setGlobalVariablesActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'global-variables');
            },
            setPropertyVariablesActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'property-variables');
            },
            setInvoiceVariablesActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'invoice-variables');
            },
            customVariablesRedirect() {
                this.setGlobalVariablesActiveTab();
                this.$router.push(`/app/custom-variable/global-variables/`);
            },
        }
    }
</script>